
const SEARCH_RESULTS_TEMPLATE = `
    <section id="alphafilter-component"></section>
    <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12 my-20" style="text-align: center">
        <div id="search-filter-component"></div>
        <div class="clearfix"></div>
    </div>
    <div id="search-results" class="col-lg-8 col-md-9 col-sm-12 col-xs-12"></div>
    <section id="pagination-component" class="col-lg-8 col-md-9 col-sm-12 col-xs-12 pull-right"></section>
`;

const SearchResultsPage = Backbone.View.extend({
    
    className: "container",
    
    components: {
        alphafilter: {},
        bookCollectionView: {},
        searchFilter: {},
        pagination: {}
    },

    displayedCollection: {},

    template: _.template( SEARCH_RESULTS_TEMPLATE ),
    
    initialize: function() {
        // init params
        this.displayedCollection = this.collection.clone().paginate(0);
        this.paginationCollection = this.collection.clone();
        this.alphaCollection = this.collection.clone();

        // init components
        this.components.alphafilter = new AlphaFilterComponent({ collection: this.alphaCollection });
        this.components.bookCollectionView = new BookCollectionView({ collection: this.displayedCollection, column: 3 });
        this.components.searchFilter = new SearchFilterComponent({ collection: this.collection });
        this.components.pagination = new PaginationComponent({ collection: this.paginationCollection });

        // listen to the events of the subcomponents
        this.components.alphafilter.el.addEventListener("letter", (e) => this.updateAlpha(e.detail.collection()));
        this.components.pagination.el.addEventListener("page", (e) => this.updateDisplayedCollection(e.detail.collection()));
        this.components.searchFilter.el.addEventListener("filter", (e) => this.updateFilter(e.detail.collection()));
    },

    render: function() {
        this.$el.html(this.template());
        this.$el.find("#search-results").html(this.components.bookCollectionView.render().el);
        this.$el.find("#alphafilter-component").html(this.components.alphafilter.render().el);
        this.$el.find("#search-filter-component").html(this.components.searchFilter.render().el);
        this.$el.find("#pagination-component").html(this.components.pagination.render().el);

        return this;
    },

    afterRender: function() {
        // this function is necessary for app.render
    },  

    updateFilter: function(newCollection) {
        // Will automatically update the alphafilter's and bookCollectionView's collection
        // They will re-render themselves
        this.paginationCollection.set(newCollection);
        this.alphaCollection.set(newCollection);
        this.updateDisplayedCollection(newCollection)
    },

    updateAlpha: function(newCollection) {
        this.paginationCollection.set(newCollection);
        this.updateDisplayedCollection(newCollection);
    },

    updateDisplayedCollection: function(newCollection) {
        this.displayedCollection.set(newCollection.slice(0, 12))
    }
});